"use client"

import { createContext, useContext, useState } from "react";

// 定义类型
type ModalContextType = {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  isLoginOpen: boolean;
  setIsLoginOpen: (isOpen: boolean) => void;
  isRegisterOpen: boolean;
  setIsRegisterOpen: (isOpen: boolean) => void;
};

// 创建 Context
export const ModalContext = createContext<ModalContextType | undefined>(undefined);

// 创建 Provider 组件
export function ModalProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);


  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const [isRegisterOpen, setIsRegisterOpen] = useState(false);

  const contextValue: ModalContextType = {
    isOpen,
    openModal,
    closeModal,
    isLoginOpen,
    setIsLoginOpen,
    isRegisterOpen,
    setIsRegisterOpen,
  };

  return (
    <ModalContext.Provider value={contextValue}>
      {children}
    </ModalContext.Provider>
  );
}

// 创建自定义 Hook
export function useModal() {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within ModalProvider");
  }
  return context;
}
